import { panelApi } from '../services/api'

export const PANEL_REMEMBER_KEY = 'panel_remember_password'
export const PANEL_SAVED_USERNAME_KEY = 'panel_saved_username'
export const PANEL_SAVED_PASSWORD_KEY = 'panel_saved_password'
/** 面板活跃时每隔 30 分钟自动续期一次 */
export const PANEL_SESSION_REFRESH_MS = 30 * 60 * 1000

export function isPanelRememberEnabled(): boolean {
  return localStorage.getItem(PANEL_REMEMBER_KEY) === '1'
}

export function loadRememberedCredentials(): { username: string; password: string } | null {
  if (!isPanelRememberEnabled()) return null
  const username = localStorage.getItem(PANEL_SAVED_USERNAME_KEY) || ''
  const password = localStorage.getItem(PANEL_SAVED_PASSWORD_KEY) || ''
  if (!username) return null
  return { username, password }
}

export function saveRememberedCredentials(username: string, password: string, remember: boolean): void {
  if (remember) {
    localStorage.setItem(PANEL_REMEMBER_KEY, '1')
    localStorage.setItem(PANEL_SAVED_USERNAME_KEY, username)
    localStorage.setItem(PANEL_SAVED_PASSWORD_KEY, password)
  } else {
    clearRememberedCredentials()
  }
}

export function clearRememberedCredentials(): void {
  localStorage.removeItem(PANEL_REMEMBER_KEY)
  localStorage.removeItem(PANEL_SAVED_USERNAME_KEY)
  localStorage.removeItem(PANEL_SAVED_PASSWORD_KEY)
}

export function persistPanelSession(accessToken: string, tokenId: number): void {
  localStorage.setItem('panel_token', accessToken)
  localStorage.setItem('panel_token_id', String(tokenId))
}

export async function refreshPanelSession(): Promise<{ token_id: number } | null> {
  const pt = localStorage.getItem('panel_token')
  if (!pt) return null
  try {
    const res = await panelApi.refreshSession()
    persistPanelSession(res.access_token, res.token_id)
    return { token_id: res.token_id }
  } catch {
    return null
  }
}
